import apiService from "./BaseApi";
const ENDPOINT = "dashboard";
import store from '@/store/index'
const DashboardService = {
    findKPIbyUnit: async (unit_id) => apiService.post(ENDPOINT + "/byUnit", { currentUserId: store.state.currentUser?.uid, unit_id }),
};

export default DashboardService;
